// src/components/GoogleTag.js
import { useEffect } from 'react';

const GoogleTag = () => {
  useEffect(() => {
    // Dodaj pierwszy skrypt
    const script1 = document.createElement('script');
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16960208448';
    script1.async = true;
    document.head.appendChild(script1);

    // Dodaj drugi skrypt
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16960208448');
    `;
    document.head.appendChild(script2);
  }, []);

  return null;
};

export default GoogleTag;
